/*
 * sorting-headers-enum.ts
 * dev-utms-shop-admin
 * 
 * Last Modified: 23.05.2024
 * Modified By: Tetiana Makovii
 * 
 * Created by Tetiana Makovii on 04.07.2023
 * Copyright © 2026 Sonova AG. All rights reserved.
 */

export enum SortingHeadersEnum
{
    clinicOfficeId = "clinicOfficeId",
    name = "name",
    email = "email",
    city="city",
    brand="brand",
    hcpAmount="hcpAmount",
    entAmount="entAmount",
    patientsAmount="patientsAmount",
    status="status",
}
